document.addEventListener('DOMContentLoaded',function(){
  const menu=document.querySelector('.menu-toggle');
  const nav=document.querySelector('.main-nav');
  if(menu&&nav){
    menu.addEventListener('click',function(){
      const open=nav.classList.toggle('open');
      menu.setAttribute('aria-expanded',open?'true':'false');
    });
  }

  const toast=document.getElementById('ZafiroToast');
  function showToast(message){
    if(!toast)return;
    toast.textContent=message;
    toast.classList.add('show');
    setTimeout(()=>toast.classList.remove('show'),2500);
  }

  const qty=document.getElementById('Quantity');
  const minus=document.querySelector('[data-qty-minus]');
  const plus=document.querySelector('[data-qty-plus]');
  if(qty&&minus&&plus){
    minus.addEventListener('click',()=>{qty.value=Math.max(1,(parseInt(qty.value)||1)-1)});
    plus.addEventListener('click',()=>{qty.value=(parseInt(qty.value)||1)+1});
  }

  const form=document.querySelector('.product-form');
  if(form){
    const select=form.querySelector('#ProductSelect');
    const price=document.getElementById('ProductPrice');
    const radios=[...form.querySelectorAll('input[type="radio"][name^="option"]')];

    function syncVariant(){
      if(!select||!radios.length)return;
      const selected=radios.filter(r=>r.checked).map(r=>r.value);
      const variants=window.__ZAFIRO_VARIANTS||[];
      const match=variants.find(v=>v.options.every((o,i)=>o===selected[i]));
      if(match){
        select.value=match.id;
        if(price)price.textContent=match.price;
        form.querySelectorAll('[type="submit"]').forEach(b=>b.disabled=!match.available);
        const add=form.querySelector('.add-to-cart');
        const buy=form.querySelector('.buy-now');
        if(add)add.textContent=match.available?'Añadir al carrito':'Agotado';
        if(buy)buy.textContent='Comprar ahora';
      }
    }
    if(radios.length)radios.forEach(r=>r.addEventListener('change',syncVariant));

    form.addEventListener('submit',async function(e){
      const buyNow=e.submitter && e.submitter.hasAttribute('data-buy-now');
      if(!buyNow){
        e.preventDefault();
        const fd=new FormData(form);
        try{
          const response=await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:fd});
          if(!response.ok)throw new Error('No se pudo añadir');
          const data=await response.json();
          showToast((data.product_title||'Producto')+' añadido al carrito');
          const count=document.querySelector('.cart-count');
          if(count){
            const cart=await fetch('/cart.js').then(r=>r.json());
            count.textContent=cart.item_count;
          }
        }catch(err){
          form.submit();
        }
      }else{
        e.preventDefault();
        const fd=new FormData(form);
        try{
          const response=await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:fd});
          if(!response.ok)throw new Error('No se pudo añadir');
          window.location.href='/checkout';
        }catch(err){
          form.submit();
        }
      }
    });
  }

  const mainImage=document.querySelector('.main-product-image img');
  document.querySelectorAll('.thumb').forEach(button=>{
    button.addEventListener('click',()=>{
      if(!mainImage)return;
      mainImage.src=button.dataset.imageUrl;
      mainImage.alt=button.dataset.imageAlt||'';
    });
  });

  const cartForm=document.getElementById('CartForm');
  if(cartForm){
    cartForm.addEventListener('submit',async function(e){
      if(e.submitter && e.submitter.name==='update'){
        e.preventDefault();
        const fd=new FormData(cartForm);
        try{
          await fetch('/cart/update.js',{method:'POST',headers:{'Accept':'application/json'},body:fd});
          window.location.reload();
        }catch(err){cartForm.submit();}
      }
    });
  }
});